import { render } from "./PhoneField.vue?vue&type=template&id=a0c274fa"
import script from "./PhoneField.vue?vue&type=script&lang=js"
export * from "./PhoneField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/PhoneField.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a0c274fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a0c274fa', __exports__)) {
    api.reload('a0c274fa', __exports__)
  }
  
  module.hot.accept("./PhoneField.vue?vue&type=template&id=a0c274fa", () => {
    api.rerender('a0c274fa', render)
  })

}


export default __exports__